import {
  createContext,
  useState,
  useCallback,
  useMemo
} from "react";

import alarmConfig from "../config/alarmConfig";

export const AlarmContext =
  createContext();

export function AlarmProvider({
  children
}) {

  const [
    activeAlarms,
    setActiveAlarms
  ] = useState([]);


  // =========================================
  // 🔥 TOGGLE BUZZER
  // ========================================= 

  const toggleBuzzer = useCallback((tag) => {

    setActiveAlarms(prev =>
      prev.map(alarm => {

        if (alarm.tag !== tag) return alarm;

        const newMuteState = !alarm.buzzerOn;

        return {
          ...alarm,
          buzzerOn: newMuteState,

          mutedAt: newMuteState
            ? new Date().toISOString()
            : null,

          muteCount: newMuteState
            ? alarm.muteCount + 1
            : alarm.muteCount
        };
      })
    );

  }, []);



  // =========================================
  // 🔥 GLOBAL ALARM ENGINE
  // =========================================

  const evaluateTag = useCallback((
    tag,
    value
  ) => {


    const config =
      alarmConfig[tag];


    // =============================
    // SAFETY CHECK
    // =============================

    if (
      !config ||
      !config.ranges
    ) {
      return;
    }


    const {
      description,
      ranges
    } = config;



    let type = null;
    let severity = null;



    // =====================================
    // LOW LOW
    // =====================================

    if (
      ranges.LL !== undefined &&
      value <= ranges.LL
    ) {

      type = "LL Alarm";
      severity = "LL";

    }



    // =====================================
    // LOW
    // =====================================

    else if (
      ranges.L !== undefined &&
      value <= ranges.L
    ) {

      type = "Low Alarm";
      severity = "L";

    }



    // =====================================
    // HIGH HIGH
    // =====================================

    else if (
      ranges.HH !== undefined &&
      value >= ranges.HH
    ) {

      type = "HH Alarm";
      severity = "HH";

    }



    // =====================================
    // HIGH
    // =====================================

    else if (
      ranges.H !== undefined &&
      value >= ranges.H
    ) {

      type = "High Alarm";
      severity = "H";

    }





    // =====================================
    // UPDATE ACTIVE ALARMS
    // =====================================

    setActiveAlarms(prev => {


      const existing =
        prev.find(
          a => a.tag === tag
        );



      // =================================
      // NORMAL CONDITION
      // REMOVE ALARM
      // =================================

      if (!type) {

        const exists =
          prev.some(
            a => a.tag === tag
          );


        if (!exists)
          return prev;


        return prev.filter(
          a => a.tag !== tag
        );

      }




      // =================================
      // UPDATE EXISTING ALARM
      // =================================

      if (existing) {


        if (
          existing.value === value &&
          existing.type === type &&
          existing.severity === severity
        ) {

          return prev;

        }



        return prev.map(a =>

          a.tag === tag

            ? {
                ...a,
                value,
                type,
                severity
              }

            : a

        );

      }




      // =================================
      // CREATE NEW ALARM
      // =================================

      return [

        ...prev,

        {
          tag,

          description,

          type,

          value,

          severity,


          timestamp:
            new Date()
              .toLocaleString(),


          buzzerOn: true,

          mutedAt: null,

          muteCount: 0
        }

      ];

    });


  }, []);




  // =========================================
  // MEMOIZED CONTEXT VALUE
  // =========================================

  const contextValue = useMemo(() => ({

    activeAlarms,

    evaluateTag,

    toggleBuzzer

  }), [

    activeAlarms,

    evaluateTag,

    toggleBuzzer

  ]);





  // =========================================
  // PROVIDER
  // =========================================

  return (

    <AlarmContext.Provider

      value={contextValue}

    >

      {children}

    </AlarmContext.Provider>

  );

}